module.exports = __webpack_public_path__ + "img/fil_bg.049eaeb0.svg";